module.exports = __webpack_public_path__ + "img/zk-icon-group-booking.05085203.svg";